<ng-container *ngIf="filtersChannel?.loadedStatus | async; else loadingFilters">
  <div
    class="sliding-container d-flex fd-row ai-stretch"
    [style.right]="selectOpen ? '100%' : '0%'"
  >
    <div class="edit-section d-flex fd-col ai-stretch" style="flex: 0 0 50%">
      <div class="header-section-outer" *ngIf="showFilterHeader">
        <div class="header-section">
          <div class="header-section-inner d-flex fd-row jc-between ai-center">
            <h4>
              <mat-icon class="filters-icon">filter_alt</mat-icon>
              <span>{{ editFiltersRef?.filters?.name }}</span>
            </h4>
            <!-- <button
              class="flex-1"
              mat-icon-button
              class="switch-filters-button"
              (click)="selectOpen = true"
            >
              <mat-icon>menu</mat-icon>
            </button> -->
          </div>
          <h5 class="active-filter-heading">
            <span
              *ngIf="editFiltersRef?.filters && !editFiltersRef?.filtersSaved && !autoSave"
              class="unsaved-changes"
            >
              (Unsaved changes)
            </span>
          </h5>

          <button mat-icon-button class="close-btn" (click)="onClose()" *ngIf="isSidenavContent">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <!-- <div class="d-flex fd-row jc-between ai-center">
          <suvo-bi-filters-title
            class="flex-1"
            *ngIf="!!editFiltersRef.filters; else loadingFilters"
            [filters]="editFiltersRef.filters"
            (titleClicked)="selectOpen = true"
            [editFiltersRef]="editFiltersRef"
            (saveFilters)="$event ? saveTemporaryFilters() : discardTemporaryFilters()"
            [autoSave]="autoSave"
          >
          </suvo-bi-filters-title>
        </div> -->
        <mat-divider></mat-divider>
      </div>
      <div
        *ngIf="!autoSave"
        class="filters-toolbar d-flex fd-row jc-between"
        [ngClass]="{ disabled: !!editFiltersRef?.filtersSaved }"
      >
        <h4 style="margin-left: 4px; margin-top: 0">{{ editFiltersHeading }}</h4>
        <div class="d-flex fd-row ai-start gap-10">
          <ng-container *ngIf="editFiltersRef?.filters">
            <!-- <button class="flex-1" mat-stroked-button (click)="editFiltersRef.clear()" [disabled]="editFiltersRef?.filtersEmpty">
                <mat-icon>close</mat-icon>
                Clear
              </button> -->
            <button
              class="flex-1"
              mat-stroked-button
              (click)="discardTemporaryFilters()"
              [disabled]="!!editFiltersRef?.filtersSaved"
            >
              <mat-icon>undo</mat-icon>
              Revert
            </button>
            <button
              class="save-button flex-1"
              mat-flat-button
              color="primary"
              (click)="saveTemporaryFilters()"
              [disabled]="!!editFiltersRef?.filtersSaved"
            >
              <mat-icon>check</mat-icon>
              Save
            </button>
            <!-- <button class="flex-1" mat-flat-button *ngIf="autoApplyFilters" [routerLink]="[filtersChannel.channelName, 'export']"
                class="export-button">
                <mat-icon>download</mat-icon>
                Export
              </button> -->
          </ng-container>
        </div>
      </div>
      <div
        class="scrolling-container d-flex fd-col ai-stretch"
      >
        <!-- No Active Filters -->

        <!-- <ng-container *ngIf="!selectedFilters">
            <div class="margin d-flex fd-col ai-start jc-center">
              <suvo-core-icon-message icon="filter_alt" title="No Selected Filters" message="Create or choose some filters.">
              </suvo-core-icon-message>
              <button mat-flat-button color="primary" (click)="createEvent.emit()">
                <mat-icon>add</mat-icon>Create Custom Filters
              </button>
            </div>
          </ng-container> -->

        <!-- Edit Filters -->
        <div class="flex-1 d-flex fd-col ai-stretch">
          <suvo-bi-edit-filters
            #editFiltersRef
            [autoApplyFilters]="autoApplyFilters"
            [filtersChannel]="filtersChannel"
            (filtersManuallyApplied)="filtersManuallyApplied.emit()"
            class="flex-1"
            [autoSave]="autoSave"
          ></suvo-bi-edit-filters>
        </div>

        <mat-divider></mat-divider>
        <!-- Toolbar -->
        <div
          class="margin d-flex fd-row jc-center gap-12"
          style="flex: 1 0"
        >
          <button mat-stroked-button class="clear-filters-button" (click)="clearFilters()">
            <mat-icon>clear</mat-icon>Reset filters
          </button>
          <ng-container *ngIf="!autoApplyFilters">
            <button
              class="search-button"
              mat-flat-button
              color="primary"
              (click)="applyFiltersClicked()"
              [disabled]="editFiltersRef.filtersApplied"
            >
              <mat-icon>search</mat-icon>
              Search
            </button>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="select-section" style="flex: 0 0 50%">
      <suvo-bi-select-filters
        [showNoneOption]="false"
        [createEvent]="createEvent"
        (close)="selectOpen = false"
        [filtersChannel]="filtersChannel"
      ></suvo-bi-select-filters>
    </div>
  </div>
</ng-container>
<ng-template #loadingFilters>
  <!-- <span> {{ filtersChannel?.channelName || 'none' }} </span> -->
  <div class="loading-filters d-flex fd-col jc-center ai-center">
    <mat-icon class="loading-filters-icon">filter_alt</mat-icon>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</ng-template>
